import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.7629 11.9188C14.1771 11.9188 14.5129 11.583 14.5129 11.1688C14.5129 10.7546 14.1771 10.4188 13.7629 10.4188V11.9188ZM15.1222 3.94135L15.856 4.09667L15.1222 3.94135ZM4.36272 10.3577L3.62623 10.4994L4.36272 10.3577ZM14.3277 7.695L13.5939 7.53968L14.3277 7.695ZM2.8422 2.45558L2.10571 2.59729L2.8422 2.45558ZM0.249955 2.39453H1.86021V0.894531H0.249955V2.39453ZM2.10571 2.59729L3.62623 10.4994L5.09921 10.216L3.57869 2.31387L2.10571 2.59729ZM5.3447 11.9188H13.7629V10.4188H5.3447V11.9188ZM3.13959 4.08781H14.6331V2.58781H3.13959V4.08781ZM14.3885 3.78603L13.5939 7.53968L15.0614 7.85031L15.856 4.09667L14.3885 3.78603ZM13.3494 7.73791H4.51878V9.23791H13.3494V7.73791ZM14.6331 4.08781C14.4742 4.08781 14.3556 3.9415 14.3885 3.78603L15.856 4.09667C16.0205 3.31936 15.4276 2.58781 14.6331 2.58781V4.08781ZM3.62623 10.4994C3.78476 11.3233 4.5057 11.9188 5.3447 11.9188V10.4188C5.22484 10.4188 5.12185 10.3337 5.09921 10.216L3.62623 10.4994ZM13.5939 7.53968C13.5695 7.65524 13.4675 7.73791 13.3494 7.73791V9.23791C14.1762 9.23791 14.8902 8.65922 15.0614 7.85031L13.5939 7.53968ZM1.86021 2.39453C1.98007 2.39453 2.08306 2.4796 2.10571 2.59729L3.57869 2.31387C3.42016 1.48998 2.69921 0.894531 1.86021 0.894531V2.39453Z",
      fill: "#AA1E2D"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "5.75982",
      cy: "14.045",
      r: "1.3106",
      fill: "#AA1E2D"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "12.4434",
      cy: "14.045",
      r: "1.3106",
      fill: "#AA1E2D"
    }, null, -1)
  ]))]))
}
export default { render: render }